import commissionsService from "@/services/commissionsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async findAll({ commit, dispatch }) {
    try {
      const res = await commissionsService.findAll();
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Provisionen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await commissionsService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Provision wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Provision konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
